export default __webpack_public_path__ + "static/588-33aac8acf9b391474dbaf7368ec67ca6.gif";